import Draw from 'ol/interaction/Draw';
import Modify from 'ol/interaction/Modify';
import Snap from 'ol/interaction/Snap';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { unByKey } from 'ol/Observable';
import Overlay from 'ol/Overlay'
// import { getArea } from 'ol/sphere';
import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import Text from 'ol/style/Text';

import { map } from './tools';

const measureTooltipElement = document.createElement('div');
measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';

const measureTooltip = new Overlay({
  element: measureTooltipElement,
  position: undefined,
  positioning: 'center-center',
  stopEvent: false,
  insertFirst: false,
});

export const initMeasure = () => {
  map.addOverlay(measureTooltip); // used when drawing closed linestrings
  map.addInteraction(modify);
  map.addInteraction(snap);
};

const area = new Text({
  backgroundFill: new Fill({ color: 'rgba(255, 255, 255, 0.8)' }),
  font: '14px sans-serif',
  padding: [2, 2, 0, 4]
});
const length = new Text({
  backgroundFill: new Fill({ color: 'rgba(255, 255, 255, 0.8)' }),
  font: '14px sans-serif',
  padding: [2, 2, 0, 4]
});

const formatArea = a => Math.round(a) / 1000 + ' daa';
const formatLength = l => (l > 1000) ?
  `${Math.round(l / 10) / 100} km}` : `${Math.round(l)} m`;

export const updateMeasure = (p) => {
  // console.log(p.getType());
  if (p.getType() === 'Polygon') area.setText(formatArea(p.getArea()));
  else length.setText(formatLength(p.getLength()));
};

export const updateMeasureTooltip = (p) => {
  measureTooltipElement.innerHTML = formatArea(p.getArea());
  measureTooltip.setPosition(p.getInteriorPoint().getCoordinates());
};

export const hideMeasureTooltip = () => measureTooltip.setPosition(undefined);

const style = {
  progress: new Style({
    image: new Circle({
      radius: 5,
      stroke: new Stroke({ color: 'rgba(0, 0, 0, 0.7)' }),
      fill: new Fill({ color: 'rgba(255, 255, 255, 0.2)' })
    }),
    stroke: new Stroke({
      color: 'rgba(0, 0, 0, 0.5)',
      lineDash: [10, 10],
      width: 2
    }),
    fill: new Fill({ color: 'rgba(255, 255, 255, 0.2)' })
    // , text: area // you get text on Points and LineStrings too
  }),
  done: new Style({
    fill: new Fill({ color: 'rgba(255, 255, 255, 0.2)' }),
    image: new Circle({ radius: 7, fill: new Fill({ color: '#ffcc33' }) }),
    stroke: new Stroke({ color: '#ffcc33', width: 2 })
    // text: area // you get area un linestrings too
  })
};
const onlyArea = new Style({ text: area });
const onlyLength = new Style({ text: length });

const addTextToStyle = (drawingStatus) => {
  const styleFunction = (f) => {
    let text;
    switch (f.getGeometry().getType()) {
      case 'Polygon':
        text = onlyArea;
        break;
      case 'LineString':
        text = onlyLength;
        break;
      default:
        // console.log('Point');
        text = new Style();
    }
    return [ style[drawingStatus], text ];
  };
  return styleFunction;
};

const source = new VectorSource();
source.on('changefeature', e => updateMeasure(e.feature.getGeometry()));

const vector = new VectorLayer({
  properties: { id: 'measure' },
  source: source,
  style: addTextToStyle('done'),
  zIndex: 2
});

let draw;
const modify = new Modify({ source });
const snap = new Snap({ source });

export const hideMeasure = () => map.removeLayer(vector);

const getMeasureType = () => {
  const p = document.querySelector('.measure-area').classList.contains('active');
  return p ? 'Polygon' : 'LineString';
};

export const setMeasure = (a) => {
  // console.log('setMeasure', a, getMeasureType());
  if (a) {
    let listener;
    draw?.setActive(false); // fixes two listeners active at the same time
    draw = new Draw({
      source: source,
      type: getMeasureType(),
      style: addTextToStyle('progress')
    });
    draw.on('drawstart', e => {
      length.setText('');
      source.clear();
      map.removeLayer(vector);
      listener = e.feature.getGeometry().on('change', e => updateMeasure(e.target));
    });
    draw.on('drawend', () => {
      unByKey(listener);
      map.addLayer(vector);
    });
    map.addInteraction(draw);
  }
  draw?.setActive(a);
  modify.setActive(a);
  snap.setActive(a);
};
